export const FIELD_BORDER_WIDTH = '2px';
export const FIELD_SPACING = '18px';
